var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('buttons.share'),"title":_vm.$t('buttons.share'),"id":"share-button"},on:{"click":_vm.show}},[_c('share-icon',{staticClass:"custom-class",attrs:{"size":"1.5x"}}),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.share')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }